<template>
  <div class="diadiv">
    <el-dialog
      :title="dialog.getName"
      width="900px"
      :visible.sync="dialog.show"
      @close="resetDialogInfo"
      :close-on-click-modal="false"
    >
      <div>
        <el-tabs
          v-model="dialog.activeName"
          @tab-click="handleClick"
        >
          <el-tab-pane
            label="线索信息"
            name="first"
          >
            <div class="addRole">
              <el-form
                status-icon
                :model="ruleForm"
                ref="ruleForm"
                label-width="100px"
              >
                <p class="subtitle">基本信息</p>
                <el-row>
                  <el-col :span="8">
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      label="姓名:"
                      prop="userName"
                    >
                      {{ruleForm.userName}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      label="性别:"
                      prop="gender"
                    >
                      {{ruleForm.gender|genderMap}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      label="手机号:"
                      prop="phone"
                    >
                      {{ruleForm.phone}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item
                      label="出生日期:"
                      prop="birthday"
                    >
                      {{ruleForm.birthday|formatDate}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      label="证件类型:"
                      prop="idType"
                    >
                      {{ruleForm.idTypeDictName}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      label="证件号码:"
                      prop="idNumber"
                    >
                      {{ruleForm.idNumber}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item
                      label="国籍:"
                      prop="nation"
                    >
                      {{ruleForm.nation}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      label="民族:"
                      prop="people"
                    >
                      {{ruleForm.people}}
                    </el-form-item>
                  </el-col>
                  <el-col
                    :span="8"
                    class='adressstyle'
                  >
                    <el-form-item
                      label="户籍所在地:"
                      prop="residenceAddress"
                    >
                      {{pName}}
                      {{cName}}
                      {{aName}}
                      {{ruleForm.residenceAddress}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item
                      label="婚姻状态:"
                      prop="marriage"
                    >
                      {{ruleForm.marriage|marriageMap}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      label="子女情况:"
                      prop="fertilityStatus"
                    >
                      {{ruleForm.fertilityStatus}}
                    </el-form-item>
                  </el-col>
                  <el-col
                    :span="8"
                    class='adressstyle'
                  >
                    <el-form-item
                      label="居住地:"
                      prop="address"
                    >
                      {{apName}}
                      {{acName}}
                      {{aaName}}
                      {{ruleForm.address}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item
                      label="学历:"
                      prop="education"
                    >
                      {{ruleForm.education|educationMap}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <p class="subtitle">资产信息</p>

                <el-row>
                  <el-col :span="8">
                    <el-form-item
                      label="职业:"
                      prop="profession"
                    >
                      {{ruleForm.profession}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      label="行业类型:"
                      prop="industry"
                    >
                      {{ruleForm.industry}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      label="年收入:"
                      prop="incomeYearly"
                    >
                      {{ruleForm.incomeYearly|incomeMap}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item
                      label="是否有房:"
                      prop="hasHouse"
                    >
                      {{ruleForm.hasHouse|tOrfMap}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      label="是否有车:"
                      prop="hasCar"
                    >
                      {{ruleForm.hasCar|tOrfMap}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <p class="subtitle">相关信息</p>
                <el-row>
                  <el-col :span="8">
                    <el-form-item
                      label="线索ID:"
                      prop="id"
                    >
                      {{ruleForm.id}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      label="客户状态:"
                      prop="saleStatus"
                    >
                      {{ruleForm.saleStatus|saleStatusMap}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      label="客户经理ID:"
                      prop="customerManagerWorkNo"
                    >
                      {{ruleForm.customerManagerWorkNo}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item
                      label="客户经理姓名:"
                      prop="customerManager"
                    >
                      {{ruleForm.customerManager}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      label="创建时间:"
                      prop="createTime"
                    >
                      {{ruleForm.createTime|formatTime}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      label="创建人ID:"
                      prop="creatorUserId"
                    >
                      {{ruleForm.creatorUserId}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item
                      label="归属机构ID:"
                      prop="ownerOrganizationCode"
                    >
                      {{ruleForm.ownerOrganizationCode}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      label="修改时间:"
                      prop="updateTime"
                    >
                      {{ruleForm.updateTime|formatTime}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      label="修改人ID:"
                      prop="updateUserId"
                    >
                      {{ruleForm.updateUserId}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item
                      label="关联客户号:"
                      prop="linkedCustomerNo"
                    >
                      {{ruleForm.linkedCustomerNo}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      label="客户备注:"
                      prop="remark"
                    >
                      {{ruleForm.remark}}
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <div class="spanstyle">
                <span slot="footer">
                  <el-button @click="dialog.show=false">取 消</el-button>
                  <el-button
                    type="primary"
                    @click="editTask()"
                  >修 改</el-button>
                </span>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane
            label="操作历史"
            name="second"
          ><template>
              <el-table
                ref="multipleTable"
                :data="tableData"
              >
                <el-table-column
                  v-for='(item,index) in tableList'
                  :prop="item.prop"
                  :label="item.label"
                  :width="item.width"
                  :key='index'
                >
                </el-table-column>
              </el-table>
            </template>
            <yh-pagination
              :page.sync="currentPage"
              :total="sumCount"
            />
            <div class='spanstyle'>
              <span slot="footer">
                <el-button @click="dialog.show=false">关 闭</el-button>
              </span>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import { addNav } from '@/mixins';

export default {
  name: 'YhLeadDetail',
  props: {
    dialog: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [addNav],
  data() {
    return {
      activeName: this.dialog.activeName,
      tableList: [
        {
          prop: 'operateType',
          label: '操作类型',
          width: '80',
        },
        {
          prop: 'operateTime',
          label: '操作时间',
          width: '100',
        },
        {
          prop: 'operatorId',
          label: '操作人ID',
        },
        {
          prop: 'operatorName',
          label: '操作人姓名',
        },
        {
          prop: 'operatorRole',
          label: '操作人角色',
        },
        {
          prop: 'customerManager',
          label: '分配对象',
        },
        {
          prop: 'operationDesc',
          label: '备注',
        },
      ],
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      sumCount: 0,
    };
  },
  filters: {
    genderMap(str) {
      const mapStr = {
        0: '女',
        1: '男',
      };
      return mapStr[str] || '';
    },
    idTypeMap(str) {
      const mapStr = {
        0: '身份证',
      };
      return mapStr[str] || '';
    },
    marriageMap(str) {
      const mapStr = {
        0: '未婚',
        1: '已婚',
      };
      return mapStr[str] || '';
    },
    educationMap(str) {
      const mapStr = {
        0: '--无--',
        1: '专科',
        2: '本科',
        3: '硕士及硕士以上',
      };
      return mapStr[str] || '';
    },
    incomeMap(str) {
      const mapStr = {
        0: '5万以内',
        1: '5~10万',
        2: '10~20万',
        3: '20~50万',
        4: '50万以上',
      };
      return mapStr[str] || '';
    },
    tOrfMap(str) {
      const mapStr = {
        0: '否',
        1: '是',
      };
      return mapStr[str] || '';
    },
    saleStatusMap(str) {
      const mapStr = {
        1: '线索客户',
        2: '已转化',
        3: '无效客户',
      };
      return mapStr[str] || '';
    },
  },
  computed: {
    isShow() {
      return this.dialog.show;
    },
    ruleForm() {
      return this.dialog.leadsData[0] || {};
    },
    pName() {
      return this.dialog.pName;
    },
    apName() {
      return this.dialog.apName;
    },
    cName() {
      return this.dialog.cName;
    },
    acName() {
      return this.dialog.acName;
    },
    aName() {
      return this.dialog.aName;
    },
    aaName() {
      return this.dialog.aaName;
    },
  },
  watch: {
    isShow(v) {
      if (!v) {
        this.currentPage = 1;
      }
    },
    currentPage: {
      immediate: true,
      handler() {
        this.getHistoryData();
      },
    },
  },
  methods: {
    resetDialogInfo() {
      this.dialog.show = false;
      this.dialog.pName = '';
      this.dialog.apName = '';
      this.dialog.cName = '';
      this.dialog.acName = '';
      this.dialog.aName = '';
      this.dialog.aaName = '';
    },
    editTask() {
      this.dialog.show = false;
      this.addNav({
        name: '修改线索',
        path: '/editLead',
      });
      sessionStorage.setItem('ID', this.ruleForm.id);
      sessionStorage.setItem(
        'detailData',
        JSON.stringify(this.dialog.leadsData[0]),
      );
    },
    getHistoryData() {
      const parames = {
        pageMessage: {
          pageSize: this.pageSize,
          pageNo: this.currentPage,
        },
        data: {
          salesLeadId: this.dialog.detailId,
        },
      };
      this.$_post(this.$API.leadOperateHistory, parames).then((res) => {
        this.tableData = res.data.list;
        this.sumCount = res.sumCount || 0;
      });
    },
    handleClick(tab) {
      if (tab.name === 'second') {
        this.getHistoryData();
      }
    },
  },
};
</script>

<style lang="scss">
.spanstyle {
  text-align: right;
  margin-top: 10px;
}
.subtitle {
  padding: 20px 0 0 1em;
  text-align: left;
  color: #409eff;
}
.hideinput {
  margin-right: 33%;
  border-style: none;
  background-color: transparent;
  border: 0px;
  outline: none;
  // white-space:normal;
  // word-wrap:break-word;
  // word-break:break-all"
}
.diadiv .el-dialog__body {
  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: #f5f7fa;
  }
  max-height: 60vh;
  overflow-y: auto;
}
</style>
<style>
.el-tooltip__popper {
  max-width: 300px;
}
</style>
>
